module.exports = __webpack_public_path__ + "static/media/6.4e9b38f6.png";